// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";

import { currentPageNumber, numberFormat, unitConvert, returnFastDfsUrl } from '@/common';
import {
    validateNumber,
    validateNumberLength,
    validatePLusMinusNumber,
    validateRate,
    validateContactWay
} from "@/utils/validate.js";
import "./icons";
import { globalsMixin } from '@/utils/mixin'

import TableComponent from '@/components/TableComponent/TableComponent.vue';
import TableSearchComponents from '@/components/TableSearch/tableSearch.vue';
import CommonNavBar from '@/components/Navbar.vue';
import CommonFooter from "@/components/Footer.vue";
import LeftNavVue from '@/components/LeftNav.vue';
import AgeementVue from "@/components/Agreement.vue";
import RightLoginVue from '@/components/RightLogin.vue';
import CommonBannerVue from "@/components/PageBanner.vue";

// 动画库 animate
import "vue2-animate/dist/vue2-animate.min.css";

// ElementUI 引用
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 自定义样式引用
import "./styles/reset.min.css";
import "./styles/element-ui-reset.min.css";
import "./styles/scssCompile.min.css";
import "./styles/common.min.css";

// 全屏滚动 vue-fullpage.js
import "fullpage.js/vendors/scrolloverflow";
import "./../static/fullPage.min.css";
import VueFullpage from "vue-fullpage.js";

// 视频播放器
import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
// swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
// import 'swiper/css/swiper.css';
import "./assets/css/swiper.min.css";

// axios
import Axios from "axios";
import interfaceAPI from "./interfaceAPI/index";

// 自定义指令
import Directives from './directives';

import echarts from 'echarts'

import moment from 'moment';
Vue.prototype.$moment = moment;
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;
Vue.prototype.InterFaceAPI = interfaceAPI;
Vue.prototype.currentPageNumber = currentPageNumber;
Vue.prototype.$EventBus = new Vue();
Vue.prototype.numberFormat = numberFormat;
Vue.prototype.unitConvert = unitConvert;
Vue.prototype.returnFastDfsUrl = returnFastDfsUrl;

// 各类校验
Vue.prototype.validateNumber = validateNumber;
Vue.prototype.validateNumberLength = validateNumberLength;
Vue.prototype.validatePLusMinusNumber = validatePLusMinusNumber;
Vue.prototype.validateRate = validateRate;
Vue.prototype.validateContactWay = validateContactWay;

Vue.use(ElementUI).use(VueFullpage).use(VueDPlayer).use(VueAwesomeSwiper).use(Directives);

Vue.component('TableComponent', TableComponent);
Vue.component('TableSearchComponents', TableSearchComponents);
Vue.component('CommonNavBar', CommonNavBar);
Vue.component('CommonFooter', CommonFooter);
Vue.component('LeftNavVue', LeftNavVue);
Vue.component('RightLoginVue', RightLoginVue);
Vue.component('CommonBannerVue', CommonBannerVue);
Vue.component('AgeementVue', AgeementVue);

// Vue.component('EnterpriseVisitVue', EnterpriseVisitVue);

export const mixin = {
  install: function(Vue) {
    Vue.mixin(globalsMixin)
  }
};
Vue.use(mixin);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js